import { ENV_TYPE } from 'lib/constants/login';
import sessionRequest from '../network/login';
import cookie from '../cookie';
import { COOKIES_KEY } from '../cookie/constants';
import msdkUtil from '../MSDK';
import network from '../network';

const ONE_HOUR = 60 * 3600 * 1000;

class Session {
  private token: string;
  private nickName: string;
  private loginType: string;
  private lastCheckTokenTime: number;
  private validTokenChecking: Promise<string> | null;

  constructor() {
    this.init();
  }

  public init() {
    this.token = cookie.get(COOKIES_KEY.LOGIN_TOKEN) || '';
    this.nickName = cookie.get(COOKIES_KEY.LOGIN_NAME) || '';
    this.loginType = cookie.get(COOKIES_KEY.LOGIN_TYPE) || '';
  }

  public login(loginData: any) {
    this.setSessionData(loginData);
  }

  public logout() {
    // 重置成无登录态请求
    network.setLoginStatus(ENV_TYPE.GUEST);
    this.clearSession();
  }

  public getSessionData() {
    return {
      token: this.token,
      nickName: this.nickName,
      loginType: this.loginType,
    };
  }

  public checkIsLogin() {
    if (Boolean(this.validTokenChecking)) {
      return this.validTokenChecking;
    }
    if (msdkUtil.isMSDK) {
      return true;
    }

    if (!this.token) return false;
    this.validTokenChecking = this.checkSession(this.token);
    return this.validTokenChecking;
  }

  // 缓存一个小时，不校验登录
  private async checkSession(token: string) {
    if (Date.now() - this.lastCheckTokenTime < ONE_HOUR) {
      return this.token;
    }
    const res = await sessionRequest.checkSession(token);
    this.validTokenChecking = null;
    if (res?.code !== 0) {
      this.clearSession();
      return '';
    }
    this.lastCheckTokenTime = Date.now();
    return this.token;
  }

  private clearSession() {
    this.setSessionData({});
    [COOKIES_KEY.LOGIN_NAME, COOKIES_KEY.LOGIN_TOKEN, COOKIES_KEY.LOGIN_TYPE].map(c => cookie.delete(c));
  }

  private setSessionData({ token = '', nickName = '', loginType = '' }) {
    this.token = token;
    this.nickName = nickName;
    this.loginType = loginType;
  }
}

const session = new Session();

export default session;
